import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useState } from "react";

const Form = () => {
  const navigate = useNavigate();
  const [complaint,setComplaint] = useState('');
  const [problem, setProblem] = useState('');
  const [mediaclHistory, setMedicalHistory] = useState('');
  const [take, setTake] = useState('');
 
  return (
    <>
      <Header />
      <Sidebar
      //   id="menu-item"
      //   id1="menu-items"
      //   activeClassName="card-patientdashboard"
      />
      <div className="page-wrapper">
        <div className="content">
          {/*Page Header line*/}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">See Doctor Now </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">Book Appointment</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <div className="card-title">
                <div className="col-12">
                  <div className="form-heading">
                    <h4>Appointment Details</h4>
                  </div>
                </div>
              </div>
              <form onSubmit={()=>navigate("/appointment")}>
                <div className="row">
                  <div className="col-12 col-sm-5 mt-2">
                    <div className="form-group local-forms">
                      <label>
                        Presenting Complaint{" "}
                        <span className="login-danger">*</span>
                      </label>
                      <textarea
                        value={complaint}
                        onChange={(e) => setComplaint(e.target.value)}
                        className="form-control"
                        rows={4}
                        cols={30}
                        defaultValue={""}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-5 mt-2">
                    <div className="form-group local-forms">
                      <label>
                        When Problem Started{" "}
                        <span className="login-danger">*</span>
                      </label>
                      <textarea
                        value={problem}
                        onChange={(e) => setProblem(e.target.value)}
                      className="form-control"
                        rows={4}
                        cols={30}
                        defaultValue={""}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-5 mt-2">
                    <div className="form-group local-forms">
                      <label>
                        Past Medical History{" "}
                        <span className="login-danger">*</span>
                      </label>
                      <textarea
                        value={mediaclHistory}
                        onChange={(e) => setMedicalHistory(e.target.value)}
                        className="form-control"
                        rows={4}
                        cols={30}
                        defaultValue={""}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-5 mt-2">
                    <div className="form-group local-forms">
                      <label>
                        Any Medications You Are Taking{" "}
                        <span className="login-danger">*</span>
                      </label>
                      <textarea
                        value={take}
                        onChange={(e) => setTake(e.target.value)}
                        className="form-control"
                        rows={4}
                        cols={30}
                        defaultValue={""}
                      />
                    </div>
                  </div>
                  <div className="input-group mb-3 col-xl-6 mt-2">
                    <input
                      type="file"
                      className="form-control"
                      id="inputGroupFile02"
                    />
                    <label
                      className="input-group-text"
                      htmlFor="inputGroupFile02"
                    >
                      Upload
                    </label>
                  </div>
                  <div className="col-12 mt-2"> 
                       <div className="form-group select-gender">
                          <label className="gen-label">Payment<span className="login-danger">*</span></label>
                          <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  name="gender"
                                  className="form-check-input"
                                />
                                Debit/card
                              </label>
                            </div>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  name="gender"
                                  className="form-check-input"
                                />
                               Medical Insurance
                              </label>
                            </div>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  name="gender"
                                  className="form-check-input"
                                />
                                Mobile Money
                              </label>
                            </div>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  name="gender"
                                  className="form-check-input"
                                />
                                Electronic Funds Transfer
                              </label>
                            </div>
                       </div>
                  </div>
                  <div className="col-12">
                    <div className="doctor-submit text-end">
                      <button
                      
                        type="submit"
                        className="btn btn-primary submit-form me-2"
                      >
                        Submit
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary cancel-form"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Form;
